import { gql } from '@apollo/client';

export default gql`
  mutation updateAgentPassword($currentPassword: String!, $newPassword: String!) {
    updateAgentPassword(currentPassword: $currentPassword, newPassword: $newPassword) {
      passwordExpiry
    }
  }
`;
